import axios from 'lib/axios'

export const getPayslipStyle = () => {
  return axios.get('admin/payroll/payslip-style')
}

export const updatePayslipStyle = (data) => {
  return axios.post('admin/payroll/payslip-style', data)
}

export const previewPayslipStyle = (data) => {
  return axios.post('admin/payroll/payslip-style/preview', data, {
    responseType: 'text',
    headers: {
      Accept: 'text/html',
    },
    transformResponse: [(response) => response],
  })
}

export const getPayslipStylePreview = () => {
  return axios.get('admin/payroll/payslip-style/preview', {
    responseType: 'text',
    headers: {
      Accept: 'text/html',
    },
    transformResponse: [(data) => data],
  })
}
